import Home from './pages/home.jsx';
import About from './pages/about.jsx';
import Bijaipur from './pages/bijaipur.jsx';
import ModiyaMahadev from './pages/modiya-mahadev.jsx';
import Paangarh from './pages/paangarh.jsx';
import ContactUs from './pages/contact-us.jsx';

// Single source of truth for routing. The client router (src/Router.jsx) and the
// build-time prerenderer (scripts/prerender.js) both read this, so a new page only
// needs to be added here to be both routable and prerendered.
export const routes = [
  { path: '/', Component: Home },
  { path: '/about', Component: About },
  { path: '/bijaipur', Component: Bijaipur },
  { path: '/modiya-mahadev', Component: ModiyaMahadev },
  { path: '/paangarh', Component: Paangarh },
  { path: '/contact-us', Component: ContactUs },
];
